<!-- eslint-disable vue/no-v-html -->
<template>
  <VendorBasicPage>
    <div
      class="tw-bg-[white] tw-w-[100%] tw-h-[100%] tw-rounded-[6px] box-shadow-contain"
    >
      <div
        :class="`tw-rounded-t-[6px] tw-border-solid tw-border-t-[0px] tw-border-x-[0px] tw-border-b-[#EFF0F1] tw-border-b-[1px]  tw-justify-between sm:tw-flex tw-bg-[white] xl:tw-py-[60px] xl:tw-px-[60px] tw-p-[20px] ${
          orgDetail?.logoImageSrc ? 'tw-items-center' : ''
        }`"
      >
        <div
          v-if="orgDetail"
          :class="`tw-flex ${imgOrgLogo ? 'tw-flex-col' : 'tw-h-[70px]'} ${
            imgOrgLogo ? 'tw-gap-[10px]' : 'tw-gap-[23.3px]'
          } 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px]`"
        >
          <div
            v-if="!vendorChecklistVendorRequested?.orgName"
            class="custom-global-skeleton tw-w-[70px] tw-h-[70px] tw-rounded-[6px]"
          ></div>
          <OrgAvatar
            v-else
            :name="vendorChecklistVendorRequested?.orgName[0]"
            :src-img="imgOrgLogo ? imgOrgLogo : ''"
            :class-name="imgOrgLogo ? '!tw-h-[134px]' : ''"
            :img-class-name="'!tw-h-full'"
          />
          <div
            v-if="!vendorChecklistVendorRequested?.orgName"
            class="custom-global-skeleton tw-w-[300px] tw-h-[70px] tw-rounded-[6px]"
          ></div>
          <div
            v-else
            class="tw-flex tw-uppercase tw-tracking-wide tw-flex-col tw-gap-1 tw-justify-center tw-text-[#211F58] tw-font-semibold"
            :class="orgDetail?.logoImageSrc ? '' : 'tw-h-[70px]'"
          >
            <span class="tw-text-[25px] tw-leading-[23px] tw-w-[300px]">
              {{ vendorChecklistVendorRequested?.orgName.split(" ")[0] }}
            </span>
            <span class="tw-text-[25px] tw-leading-[23px] tw-w-[300px]">
              {{
                vendorChecklistVendorRequested?.orgName
                  .split(" ")
                  .slice(1)
                  .join(" ")
              }}
            </span>
          </div>
        </div>
        <div
          v-else
          class="tw-flex 2xl:tw-w-1/2 xl:tw-mb-[0px] tw-mb-[10px] tw-h-[70px] tw-w-[70px] bg-skeleton"
        ></div>
        <div
          :class="`2xl:tw-w-1/2 ${
            orgDetail?.logoImageSrc ? 'tw-mb-[33px]' : ''
          }`"
        >
          <div class="md:tw-flex tw-w-full tw-justify-between md:tw-mb-[0px]">
            <div></div>
            <div class="tw-flex-shrink-0">
              <div
                class="tw-mb-[12px] tw-leading-[19px] tw-text-[13px] tw-text-[#211F58] tw-font-semibold md:tw-mt-[0px] tw-mt-[10px]"
              >
                {{
                  getComponentUiText("app-share-cyber-profile-powered-by-1")
                }}:
              </div>
              <div><CyberSystem /></div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isLoading"
        class="custom-global-skeleton tw-bg-[#ffffff] !tw-max-w-[2000px] tw-min-w-0 tw-h-[112px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1]"
      ></div>
      <div
        id="vendor-assess-external-input-interview"
        class="tw-bg-[white] xl:tw-pt-[50px] xl:tw-pb-[55px] xl:tw-px-[60px] tw-p-[20px]"
      >
        <div
          class="tw-w-full tw-items-center tw-flex tw-justify-between tw-mb-[20px]"
        >
          <p class="tw-mb-[0]">
            <span
              class="tw-text-[32px] tw-font-[600] tw-text-[#211F58]"
              data-cy="vendor-checklist-requested-name"
              v-html="titleText"
            >
            </span>
          </p>
          <div
            id="vendor-assessments-input-header-popover"
            class="tw-w-[46px] tw-h-[44px] tw-items-center tw-flex tw-justify-center"
            style="
              border-radius: 6px;
              border: 1px solid var(--UI-rule, #eff0f1);
              background: var(--UI-white, #fff);
              box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
            "
          >
            <PopoverAssessment
              id-popover="popover-vendor-assessments-input-header-option"
              padding="14px 13px"
              :disable="true"
            >
            </PopoverAssessment>
          </div>
        </div>

        <NoteInfo
          v-if="
            notInfoVisible && !isCheckStatusInprogAndWait && !isGettingStatus
          "
          background-color="#FE9A0526"
          class="tw-mb-[20px]"
          @close="notInfoVisible = false"
        >
          {{
            getComponentUiText(
              "app-vendor-assessment-external-input-flowing-banner-1",
              false,
              {
                orgName: vendorChecklistVendorRequested.orgName,
              },
            )
          }}
        </NoteInfo>

        <div
          v-if="vendorChecklistVendorRequested.descriptionExternal"
          id="vendor-assess-external-input-description"
          class="tw-bg-[#F2F8FF] tw-p-[20px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
        >
          <span class="tw-text-[15px] tw-font-400 tw-text-[#231F20]">{{
            vendorChecklistVendorRequested.descriptionExternal
          }}</span>
        </div>

        <div
          v-if="!isLoading"
          class="tw-grid tw-grid-cols-2 vendor-card-container tw-mt-[20px] tw-gap-[20px]"
        >
          <div class="vendor-card tw-col-span-2 md:tw-col-span-1">
            <VendorStatusCard
              v-if="!isLoadingRequestedInput"
              :is-show-tag="true"
              :is-show-score="false"
              :status="{
                statusId: vendorChecklistVendorRequested.statusId,
                radialValue: (
                  vendorChecklistVendorRequested.completionPcnt * 100
                ).toFixed(),
                progress: {
                  completed: vendorChecklistVendorRequested.completion,
                  total: vendorChecklistVendorRequested.itemCountApplicable,
                  percent: parseFloat(
                    (
                      (vendorChecklistVendorRequested.completion /
                        vendorChecklistVendorRequested.itemCountApplicable) *
                      100
                    ).toFixed(),
                  ),
                },
                score: {
                  completed: passedReviewTotal,
                  total: vendorChecklistVendorRequested.itemCount,
                  percent: parseFloat(
                    (
                      (passedReviewTotal /
                        vendorChecklistVendorRequested.itemCount) *
                      100
                    ).toFixed(),
                  ),
                },
              }"
              :sub-text1="
                getComponentUiText(
                  'app-component-assessments-status-card-progress-1',
                )
              "
              :sub-text2="
                getComponentUiText(
                  'app-component-assessments-status-card-passed-review-1',
                )
              "
              class="!tw-max-w-[2000px] !tw-h-[119px] tw-bg-white"
            />
            <div
              v-else
              class="custom-global-skeleton tw-bg-[#ffffff] tw-h-[112px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
            />
          </div>
          <div class="vendor-card tw-col-span-2 md:tw-col-span-1">
            <VendorCard
              v-if="!isLoadingRequestedInput"
              :vendor="vendor"
              class="!tw-max-w-[2000px] !tw-h-[119px] tw-bg-white"
            />
            <div
              v-else
              class="custom-global-skeleton tw-bg-[#ffffff] tw-h-[112px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
            />
          </div>
        </div>
        <div
          v-if="vendorChecklistVendorRequested.notesExternal"
          id="vendor-assess-external-input-notes"
          class="tw-bg-[#FCFCFD] tw-mt-[20px] tw-p-4 tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
        >
          <p
            class="tw-text-[#211F58] tw-text-[15px] tw-font-[600] tw-leading-[130%]"
          >
            {{
              getComponentUiText(
                "app-component-assessments-instructions-title-1",
              )
            }}
          </p>
          <p class="tw-text-[#231F20] tw-text-[15px] tw-font-[400]">
            {{ vendorChecklistVendorRequested.notesExternal }}
          </p>
        </div>
      </div>
      <VendorAssessmentQuestions />
    </div>
  </VendorBasicPage>
</template>

<script lang="ts" setup>
import VendorBasicPage from "./vendorBasicPage.vue";
import Utils, { getComponentUiText } from "@/utils/utilities";
import CyberSystem from "@/components/svgs/cyberSystem.vue";
import OrgAvatar from "@/components/share/orgAvatar.vue";
import VendorCard from "@/components/assessments/vendorCard.vue";
import PopoverAssessment from "@/components/assessment/popoverAssessment.vue";
import VendorAssessmentQuestions from "@/components/vendor/vendorAssessmentQuestions.vue";
import { computed, onMounted, reactive, ref, watch } from "vue";
import store from "@/store";
import VendorStatusCard from "@/components/vendor/vendorStatusCard.vue";
import { localStorageKey } from "@/utils/constants";
import { load } from "recaptcha-v3";
import NoteInfo from "@/components/common/noteInfo.vue";

const fetchData = async () => {
  store.dispatch("Vendor/fetchChecklistRequestedComplianceTypeValues", "clr");
  store.dispatch("Vendor/fetchChecklistRequestedComplianceTypeValues", "clra");
  await store.dispatch("Vendor/fetchVendorRequestedExternalInput");
};

defineProps({
  orgDetail: {
    type: Object,
    required: true,
    default: () => ({
      nameLegal: "Name Legal",
      logoImageSrc: "",
    }),
  },
  text1: {
    type: String,
    required: true,
    default:
      "This is the description ut id arcu cursus, egestas felis at, rhoncus tortor. Pellentesque vitae massa nulla. Suspendisse eros lectus, cursus et orci non, posuere condimentum erat. ",
  },
  note: {
    type: String,
    required: true,
    default:
      "This is the description ut id arcu cursus, egestas felis at, rhoncus tortor. Pellentesque vitae massa nulla. Suspendisse eros lectus, cursus et orci non, posuere condimentum erat. ",
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const notInfoVisible = ref(true);
const isGettingStatus = ref(true);
const imgOrgLogo = ref<string | null>(null);

const vendor = reactive({
  name: "",
  recipient: "",
  expiryDate: "",
  recipientFirstName: "",
  recipientLastName: "",
});

const isLoadingRequestedInput = computed(
  () => store.state.Vendor.isLoadingRequestedInput,
);

const vendorChecklistVendorRequested = computed(
  () => store.state.Vendor.checklistVendorRequestedExternalInput,
);

const isCheckStatusInprogAndWait = computed(
  () => store.getters["Vendor/isCheckStatusInprogAndWait"],
);

const assessmentQuestionTypes = computed(() => {
  return store.state.Vendor.checklistComplianceTypeValuesClra;
});

const passedReviewTotal = computed(() => {
  return (
    vendorChecklistVendorRequested.value.checklistRequestedItems?.filter(
      (item: any) => {
        let ComplianceTypeOrgValue: any;
        assessmentQuestionTypes.value.forEach((type: any) => {
          type.complianceTypeValues.forEach((value: any) => {
            if (value.id === item.checklistItemComplianceTypeValueOrgId) {
              ComplianceTypeOrgValue = value;
              return;
            }
          });
        });
        return (
          ComplianceTypeOrgValue?.value === 1 && !item.checklistItemIsHeading
        );
      },
    ).length ?? 0
  );
});

const titleText = computed(() => {
  const checklist = vendorChecklistVendorRequested.value || {};

  return getComponentUiText(
    "app-vendor-assessment-external-input-title-1",
    false,
    {
      checklistName: {
        value: checklist.name || "",
        css: "tw-font-[400]",
      },
    },
  );
});

const retrievePasswordIV = () => {
  return store.state.LanguagePicker.pwdFeIv;
};

const setLanguages = async () => {
  const passwordIV = retrievePasswordIV();
  if (
    localStorage.getItem(localStorageKey.languagesData) == null ||
    localStorage.getItem(localStorageKey.languageList) == null ||
    passwordIV === ""
  ) {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            this.$router.push({ path: "/" });
          } else {
            this.showErrorInfo(error.data.error);
          }
        } else if (error.data.message === "invalid csrf token") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data),
          );
          this.$router.push({ path: "/" });
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }
};

watch(
  () => vendorChecklistVendorRequested.value,
  (value) => {
    if (Object.keys(value).length) {
      imgOrgLogo.value = value?.checklistRequestedEmailGrants[0]?.orgLogoFile
        ? `data:image/png;base64,${value?.checklistRequestedEmailGrants[0]?.orgLogoFile}`
        : null;
      vendor.name =
        value.providerName ||
        value.providerService ||
        value.checklistRequestedEmailGrants[0]?.orgName ||
        "-";
      vendor.recipient = value.checklistRequestedEmailGrants[0]?.recipientEmail;
      vendor.expiryDate = value.checklistRequestedEmailGrants[0]?.validUntil;
      vendor.recipientFirstName =
        value.checklistRequestedEmailGrants[0]?.firstName;
      vendor.recipientLastName =
        value.checklistRequestedEmailGrants[0]?.lastName;
    }
  },
  { immediate: true, deep: true },
);

onMounted(async () => {
  setLanguages();
  await fetchData();
  isGettingStatus.value = false;
  document.getElementById("app")?.classList.add("set-overflow-y-auto");
});
</script>

<style lang="scss" scoped>
.box-shadow-contain {
  box-shadow: 2px 0px 20px 0px rgba(33, 31, 88, 0.1);
}
@media screen and (min-width: 768px) {
  .vendor-card {
    flex: 1;
  }
}
</style>
